// Doar Administrator, Vasiu Gabriela și Vasiu Victor văd sume CHF (salarii)
export const canSeeChf = (user) => {
  if (!user || user.role !== "admin") return false;
  if (isDoaga(user)) return false;
  const un = (user.username || "").trim().toLowerCase();
  const fn = (user.name || "").trim().toLowerCase();
  return ["admin", "gabi", "victor"].includes(un) || fn.includes("vasiu");
};

// Doaga Alexandru-Ionuț — admin restricționat (fără financiar, setări, calendar ore)
export const isDoaga = (user) =>
  !!user && `${user.name || ""} ${user.username || ""}`.toLowerCase().includes("doag");
